type LabelType = "EU" | "UA" | "CH";

export interface LabeledCountry {
  countryCode: string;
  labelType: LabelType;
  labelLetters: string | undefined;
  placeholder: string;
  placeholderCzech?: string;
}

export const labeledCountries: LabeledCountry[] = [
  {
    countryCode: "CZ",
    labelType: "EU",
    labelLetters: "CZ",
    placeholder: "5P35010",
    placeholderCzech: "5P35010 (ukázkový vzor)",
  },
  {
    countryCode: "DE",
    labelType: "EU",
    labelLetters: "D",
    placeholder: "NMHR716E",
  },
  {
    countryCode: "PL",
    labelType: "EU",
    labelLetters: "PL",
    placeholder: "PO665CS",
  },
  {
    countryCode: "SK",
    labelType: "EU",
    labelLetters: "SK",
    placeholder: "SC208CY",
  },
  {
    countryCode: "AT",
    labelType: "EU",
    labelLetters: "A",
    placeholder: "B779EZ",
  },
  {
    countryCode: "RO",
    labelType: "EU",
    labelLetters: "RO",
    placeholder: "CT10LSH",
  },
  {
    countryCode: "HU",
    labelType: "EU",
    labelLetters: "H",
    placeholder: "VB359V",
  },
  {
    countryCode: "NL",
    labelType: "EU",
    labelLetters: "NL",
    placeholder: "19NNBD",
  },
  {
    countryCode: "BG",
    labelType: "EU",
    labelLetters: "BG",
    placeholder: "BP2400CB",
  },
  {
    countryCode: "SE",
    labelType: "EU",
    labelLetters: "S",
    placeholder: "PWY581",
  },
  {
    countryCode: "UA",
    labelType: "UA",
    labelLetters: "UA",
    placeholder: "BM2065XP",
  },
  {
    countryCode: "IT",
    labelType: "EU",
    labelLetters: "I",
    placeholder: "DA453GM",
  },
  {
    countryCode: "DK",
    labelType: "EU",
    labelLetters: "DK",
    placeholder: "MD22335",
  },
  {
    countryCode: "CH",
    labelType: "CH",
    labelLetters: undefined,
    placeholder: "BE23184",
  },
  {
    countryCode: "FR",
    labelType: "EU",
    labelLetters: "F",
    placeholder: "EQ665CS",
  },
];
